import { PsModel } from './InsiService'

export class InsiService {
  private static endpoint = `${process.env.REACT_APP_INSI_SERVER}`

  static async findByTraits(query: GetImtiRequest): Promise<ImtiResponseDTO> {
    const url = `${this.endpoint}/imti/RechercheMedecinTraitant`
    const body = JSON.stringify(query)
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    })
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const data = await response.json()
    return data
  }
}

export interface ImtCV {
  assureNumSecu: string
  beneficiaireDateNaissance: string
  beneficiaireRang: string
  beneficiaireNumSecu: string
  codeRegime: string
  codeCaisse: string
  codeCentre: string
  numeroSerieCv: string
}

export interface GetImtiRequest {
  psModel: PsModel
  imtCV: ImtCV
  isApcv: boolean
  idJfse: number
}

interface ImtRetour {
  nom: string
  prenom: string
  numeroPsam: string
  numeroRpps: string
  numeroAdeli: string
  adresse: string
  codePostale: string
  ville: string
  pays: string
  telephone: string
  mail: string
}

interface ImtiMessage {
  reponse: {
    showQueries: boolean
    xmlQuery: string
    erreur: boolean
    erreurCode: null
    erreurMessage: string
    messageId: null
    severite: null
    erreurMessageComplet: null
  }
  imtRetour: ImtRetour
}

interface ImtiResponseDTO {
  message: ImtiMessage
}
